import PropTypes from 'prop-types'
import {
  Form,
  TextInput,
  useInput,
  useNotify,
  useRefresh,
  useRecordContext,
} from 'react-admin'
import { Button, ButtonGroup, Typography, Stack } from '@mui/material'
import { validateAutoSaveSingleInput } from '../../Utils/AutoSave'
import {
  blockInvalidCharFromNumberInput,
  numberInputOnWheelPreventChange,
} from '../../Utils/ConversionUtils'

const MotYesNoButtons = ({ source }) => {
  const {
    field: { value },
  } = useInput({ source })

  const hasMot = Number(value) > 0

  return (
    <ButtonGroup variant="contained" sx={{ boxShadow: 'none' }} disabled>
      <Button
        color={!hasMot ? 'success' : 'inherit'}
        data-confirmed={!hasMot}
        data-selected={!hasMot}
      >
        No
      </Button>
      <Button
        color={hasMot ? 'success' : 'inherit'}
        data-confirmed={hasMot}
        data-selected={hasMot > 0}
      >
        Yes
      </Button>
    </ButtonGroup>
  )
}

MotYesNoButtons.propTypes = {
  source: PropTypes.any,
}

const RemainingMOT = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()

  return (
    <Form>
      <Typography component={'span'}>MOT Remaining?</Typography>

      <Stack direction="row" spacing={1}>
        <MotYesNoButtons source="leadContact.vehicle.vehicleDocumentation.motLeft" />
        <TextInput
          source="leadContact.vehicle.vehicleDocumentation.motLeft"
          label="Months"
          type="number"
          readOnly
          defaultValue={
            record?.leadContact?.vehicle?.vehicleDocumentation?.motLeft
          }
          sx={{
            marginBottom: '-0.7rem !important',
            maxWidth: '80px',
            marginLeft: '1rem !important',
          }}
          onKeyDown={blockInvalidCharFromNumberInput}
          onWheel={numberInputOnWheelPreventChange}
          onBlur={async (e) =>
            validateAutoSaveSingleInput(
              record,
              e.target,
              notify,
              refresh,
              'MOT Remaining'
            )
          }
        />
      </Stack>
    </Form>
  )
}

export default RemainingMOT
